import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row py-3 bt-dash" }
const _hoisted_2 = { class: "f-w-700 my-3" }
const _hoisted_3 = {
  class: "custom-scrollbar list-container px-3 nav-link",
  style: {"height":"50dvh"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import { ref, reactive, onMounted, computed, watch } from 'vue'
import { LinkGroups } from '@/store/management/productsStore'
import { useProductsStore } from '@/store/management/productsStore';
import { useProductGroupsStore } from '@/store/management/productGroupsStore';

import { useI18n } from 'vue-i18n'
import { productLinkGroupsLanguage } from '@/core/locales/products-language'


export default /*@__PURE__*/_defineComponent({
  __name: 'productLinkGroups',
  setup(__props) {

const { t } = useI18n({
  messages: productLinkGroupsLanguage
})

const productStore = useProductsStore()
const productGroupsStore = useProductGroupsStore()

const compState = reactive({
    selectedProductGroup: [] as LinkGroups[],
})

onMounted(() => {
    productGroupsStore.initializeProductGroups();
});

const productGroupMock = computed((): LinkGroups[] => 
    productGroupsStore.productGroupList.map((group: any) => ({
        ...group,
        appearance: {
            displayMode: group.appearance.displayMode ?? '',
            ...group.appearance,
        }
    }))
);

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        compState.selectedProductGroup = tempActiveProduct.value?.linkGroups || [] as LinkGroups[]
    }
})

watch(activeProductId, (newVal) => {
    if (tempActiveProduct.value?.basic.productNumber) {
        compState.selectedProductGroup = activeProduct.value?.linkGroups || [] as LinkGroups[]
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        linkGroups: newVal.selectedProductGroup
    })
}, { deep: true });

const findOnSelectedProductGroup = (id: string) => {
    return compState.selectedProductGroup.find((productGroup) => productGroup.id === id)
}

const calcFontSize = (fontSize: string) => {
    return fontSize === 'X-Large' ? '1.5rem' : fontSize === 'Large' ? '1.25rem' : fontSize === 'Medium' ? '1rem' : '0.875rem'
}

const onProductGroupClick = (id: string) => {
    const productGroup = productGroupMock.value.find((productGroup: { id: string; }) => productGroup.id === id)
    if (findOnSelectedProductGroup(id)) {
        compState.selectedProductGroup = compState.selectedProductGroup.filter((productGroup) => productGroup.id !== id)
    } else {
        if (productGroup) {
            compState.selectedProductGroup.push(productGroup)
        }

    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, _toDisplayString(_unref(t)('Product Group')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroupMock.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "text-center text-white rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center gap-2",
          onClick: ($event: any) => (onProductGroupClick(item.id)),
          style: _normalizeStyle([{ backgroundColor: item.appearance.buttonColor, boxShadow: findOnSelectedProductGroup(item.id) ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none' }, {"grid-column":"span 1 / span 1","height":"112px"}])
        }, [
          (item?.appearance?.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: item.appearance.image,
                alt: "department image",
                class: "object-fit-cover w-25 ratio1-1 border-0"
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("h5", {
            class: "text-white",
            style: _normalizeStyle({ fontSize: calcFontSize(item.appearance.fontSizes) })
          }, _toDisplayString(item.name), 5)
        ], 12, _hoisted_4))
      }), 256))
    ])
  ]))
}
}

})